import { combineReducers } from 'redux-immutable';

import { DataReducer } from './DataReducer/DataReducer';
import { BaseDataStore } from './DataReducer/DataReducer.types';
import FiltersReducer from './FiltersReducer/FiltersReducer';
import { BaseFiltersStoreElement } from './FiltersReducer/FiltersReducer.types';
import { ProgressReducer } from './ProgressReducer/ProgressReducer';
import { BaseProgressStoreElement } from './ProgressReducer/ProgressReducer.types';

export interface BaseSimulationStoreElement {
  filters: BaseFiltersStoreElement;
  progress: BaseProgressStoreElement;
  data: BaseDataStore;
}

export const SimulationReducer = combineReducers<BaseSimulationStoreElement>({
  filters: FiltersReducer,
  progress: ProgressReducer,
  data: DataReducer,
});

export interface BaseSimulationStore {
  simulation: BaseSimulationStoreElement;
}
